import { render, staticRenderFns } from "./star-collector.vue?vue&type=template&id=667874de&scoped=true"
import script from "./star-collector.vue?vue&type=script&lang=ts"
export * from "./star-collector.vue?vue&type=script&lang=ts"
import style0 from "./star-collector.vue?vue&type=style&index=0&id=667874de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667874de",
  null
  
)

export default component.exports